<div class="uk-position-relative">
    <div style="margin-left: 20px; margin-top: -20px;" class="uk-position-absolute">
        <a uk-slidenav-previous></a>
        <a class="uk-link-muted uk-text-uppercase uk-link-toggle" [routerLink]="['/ressource/vehicle/list']">
            <span class="uk-link-heading">Liste des véhicules</span>
        </a>
    </div>
    <div class="uk-margin-medium-top tab">
        <ul class="uk-flex-center" uk-tab>
            <li [class.uk-active]="menu.active.tab === 'information'">
                <a [routerLink]="['/ressource/vehicle/informations', id]">Informations</a>
            </li>
            <li [class.uk-active]="menu.active.tab === 'state'">
                <a [routerLink]="['/ressource/vehicle/manager', id]">États gestionnaire</a>
            </li>
            <li [class.uk-active]="menu.active.tab === 'sinister'">
                <a [routerLink]="['/ressource/vehicle/sinisters', id]">Sinistres</a>
            </li>
        </ul>
    </div>
</div>